<template>
  <div class="contract-area-selector-wrap">

    <el-dialog title="区域选择" :visible.sync="visibleDialog" :close-on-click-modal="true" class="area-selector-dialog" width="500px">
      <div class="contract-area-selector">
        <el-tree :props="props" :load="loadNode" :data="data" :empty-text="emptyText" lazy :highlight-current="true" @node-click="nodeClick">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span class="area-manager">{{ data.manager }}</span>
          </span>
        </el-tree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit" :disabled="selected == null" :loading="loading">确 定</el-button>
        <el-button @click="visibleDialog = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import { Area } from './js/common'

export default {
  name:"contract-area-selector",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data () {
    return {
      visibleDialog: this.visible,
      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      data: [],
      selected: null,
      loading: false,
      emptyText: '',
      defEmptyText: '暂无数据',
    }
  },
  watch: {
    visible(val) {
      this.visibleDialog = val
    },
    visibleDialog(val) {
      if(val == false) {
        this.selected = null
        this.data = []
      } else {
        this.emptyText = '正在加载数据...'
        Area.getAreaList({parent_id: 0}, res => {
          this.emptyText = this.defEmptyText
          this.data = res.data
        })
      }
      this.$emit('update:visible', val)
    }
  },
  created() {

  },
  methods: {
    loadNode(node, resolve) {
      if(node.data.id) {
        Area.getAreaList({parent_id: node.data.id}, res => {
          resolve(res.data)
        })
      }
    },
    nodeClick(d) {
      this.selected = Object.assign({}, d)
    },
    submit() {
      this.loading = true
      let data = Object.assign({}, this.selected)
      this.$emit('selected', data)
      this.loading = false
      this.visibleDialog = false
      // Area.getAreaFullName({id: data.id}, res => {
      //   data.fullName = res.data.join(' -> ')
      //   this.$emit('selected', data)
      //   this.loading = false
      //   this.visibleDialog = false
      // })

    }
  }
}
</script>
<style lang="scss" scoped>

.el-button--primary {
  color: #fff;
}

.contract-area-selector {
  padding: 5px;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 300px;
  overflow: auto;
}

/deep/.custom-tree-node {
  flex: 1;
  display: flex;
  justify-content: space-between;

  .area-manager {
    padding-right: 5px;
    color: #999;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/AreaSelector.vue